import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { TOOLBAR_COLORS } from "../constants";

interface TooltipShortcutProps {
    toolName: string;
    shortcutKey: string;
}

/**
 * Component that displays tool name with keyboard shortcut in a styled format
 */
export function TooltipShortcut({ toolName, shortcutKey }: TooltipShortcutProps) {
    const { t } = useTranslation();

    return (
        <>
            {shortcutKey !== "" && (
                <Box
                    sx={{
                        padding: "0px 6px",
                        background: TOOLBAR_COLORS.TOOLTIP_BG,
                        borderRadius: "2px",
                    }}
                >
                    {shortcutKey}
                </Box>
            )}
            {t(toolName)}
        </>
    );
}
